// src/components/helper/toast.js
import { defineStore } from 'pinia'
import { ref } from 'vue'

// type: 'success' | 'danger' | 'warning' | 'info' | 'primary' | 'secondary' | 'dark' | 'light'
// position: 'top-left' | 'top-center' | 'top-right' | 'bottom-left' | 'bottom-center' | 'bottom-right'
export const useToastStore = defineStore('toast', () => {
  const toasts = ref([]) // { id, message, type, position, timeout, dismissible }
  let idSeq = 0

  // function show({
  //   message = '',
  //   type = 'info',
  //   items = null,
  //   variant = 'default',
  //   position = 'top-right',
  //   timeout = 3000,
  //   dismissible = true,
  // } = {}) {
  //   const id = ++idSeq
  //   const startedAt = Date.now()
  //   toasts.value.push({ id, message, type, items, variant, position, timeout, dismissible, startedAt })
  //   if (timeout > 0) setTimeout(() => remove(id), timeout)
  //   return id
  // }
  function show({
  message = '',
  type = 'info',
  items = null,
  variant = 'default',
  position = 'top-right',
  timeout = 3000,
  dismissible = true,
  onItemClick = null,
} = {}) {
  const id = ++idSeq
  const startedAt = Date.now()

  toasts.value.push({
    id,
    message,
    type,
    items,
    variant,
    position,
    timeout,
    dismissible,
    startedAt,
    onItemClick,
  })

  if (timeout > 0) setTimeout(() => remove(id), timeout)

  return id
}

  function remove(id) {
    toasts.value = toasts.value.filter(t => t.id !== id)
  }

  function clear(position = null) {
    toasts.value = position ? toasts.value.filter(t => t.position !== position) : []
  }

  function clearByVariant(variant) {
  toasts.value = toasts.value.filter(t => t.variant !== variant)
}

  return { toasts, show, remove, clear, clearByVariant }
})
